// Documentation :https://reactrouter.com/en/v6.3.0/getting-started/installation

import React from 'react';
import {
  baseAppRoutes,
  article11DsaAppRoutes,
  paymentServicesComplaintAppRoutes,
  reportCsamAppRoutes,
  sustainabilityAppRoutes,
  SPIMAppRoutes,
} from './Definitions';
import {
  ARTICLE_11_DSA_URL_PATTERN,
  PAYMENTS_SERVICES_COMPLAINT_PATTERN,
  REPORT_CSAM_URL_PATTERN,
  SPIM_PATTERN,
  SUSTAINABILITY_URL_PATTERN,
} from 'src/constants/UrlConstants';
import {
  createHashRouter,
  RouteObject,
  RouterProvider,
} from 'react-router-dom';
function isSustainabilityRoute(): boolean {
  return window.location.href.includes(SUSTAINABILITY_URL_PATTERN);
}

function isReportCsamRoute(): boolean {
  return window.location.href.includes(REPORT_CSAM_URL_PATTERN);
}

function isArticle11DsaPocRoute(): boolean {
  return window.location.href.includes(ARTICLE_11_DSA_URL_PATTERN);
}

function isPaymentServiceComplaintRoute(): boolean {
  return window.location.href.includes(PAYMENTS_SERVICES_COMPLAINT_PATTERN);
}

function isSPIMRoute(): boolean {
  return window.location.href.includes(SPIM_PATTERN);
}

function getRoutes(): RouteObject[] {
  if (isSustainabilityRoute()) {
    return sustainabilityAppRoutes;
  } else if (isReportCsamRoute()) {
    return reportCsamAppRoutes;
  } else if (isPaymentServiceComplaintRoute()) {
    return paymentServicesComplaintAppRoutes;
  } else if (isArticle11DsaPocRoute()) {
    return article11DsaAppRoutes;
  } else if (isSPIMRoute()) {
    return SPIMAppRoutes;
  }
  return baseAppRoutes;
}

const AppRoutes = () => {
  const router = createHashRouter(getRoutes());
  return <RouterProvider router={router} />;
};

export default AppRoutes;
